import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-blue-900 text-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <h1>
                <img 
                  src="https://static.readdy.ai/image/7ad4b11beb4e25ee1cc464ef8fd6d856/b4f984a1ec269c2588094398c65df646.png" 
                  alt="Texas Workforce Academy" 
                  className="h-12"
                />
              </h1>
            </a>
          </div>

          {/* Desktop Menu Button */}
          <div className="hidden md:block">
            <button 
              className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition-colors whitespace-nowrap"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              MENU
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white hover:text-yellow-400"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile/Desktop Menu Overlay */}
      {isMenuOpen && (
        <div className="fixed inset-0 bg-blue-900 bg-opacity-95 z-50 flex items-center justify-center">
          <div className="text-center">
            <button 
              className="absolute top-8 right-8 text-white text-2xl hover:text-yellow-400"
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="fas fa-times"></i>
            </button>
            
            <nav className="space-y-8">
              <a 
                href="/about" 
                className="block text-3xl font-bold text-white hover:text-yellow-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </a>
              <a 
                href="/#programs" 
                className="block text-3xl font-bold text-white hover:text-yellow-400 transition-colors"
                onClick={(e) => {
                  setIsMenuOpen(false);
                  if (window.location.pathname === '/') {
                    e.preventDefault();
                    const element = document.getElementById('programs');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                }}
              >
                Courses
              </a>
              <a 
                href="/wioa-program" 
                className="block text-3xl font-bold text-white hover:text-yellow-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                WIOA Program
              </a>
              <Link 
                to="/contact" 
                className="block text-3xl font-bold text-white hover:text-yellow-400 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}
